import CreateSubscriberDialog from "./CreateSubscriberModal";

export default CreateSubscriberDialog;
